module.exports = __webpack_public_path__ + "static/media/france.6b6fc685.svg";